import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, HostListener, NgModule } from '@angular/core';

class ContainerComponent {
    constructor(el) {
        this.el = el;
        this.animateOnScroll = false;
    }
    ngOnInit() {
        this.handleAnimateOnScroll();
    }
    get abc() {
        return this.animateOnScroll;
    }
    onWindowScroll() {
        this.handleAnimateOnScroll();
    }
    handleAnimateOnScroll() {
        if (!this.animateOnScroll) {
            return;
        }
        // Check window for SSR
        if (!this.el.nativeElement.getBoundingClientRect) {
            return;
        }
        const bounding = this.el.nativeElement.getBoundingClientRect();
        if (bounding.top >= 0 && bounding.top <= window.innerHeight / 2) {
            // Add opacity to the component
            this.el.nativeElement.style.setProperty('--animate-state', ((window.innerHeight / 2) - bounding.top) / ((window.innerHeight / 2)));
        }
        else if (bounding.top <= 0) {
            this.el.nativeElement.style.setProperty('--animate-state', 1);
        }
        else {
            this.el.nativeElement.style.setProperty('--animate-state', 0);
        }
    }
}
ContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ContainerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
ContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.6", type: ContainerComponent, selector: "sm-container", inputs: { animateOnScroll: "animateOnScroll" }, host: { listeners: { "window:scroll": "onWindowScroll()" }, properties: { "class.animate-background": "this.abc" } }, ngImport: i0, template: "<div class=\"width-margin\">\n  <div class=\"max-width\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host{display:flex;padding-left:var(--content-margin, 0);padding-right:var(--content-margin, 0);align-items:center}:host.animate-background{position:relative;background:var(--background-color);z-index:1}:host.animate-background:before{position:absolute;content:\"\";top:0;right:0;bottom:0;left:0;background-image:var(--linear-gradient-animation);background-position:center center;background-repeat:no-repeat;background-size:cover;z-index:-1;opacity:var(--animate-state, 0)}.width-margin{width:100%}.max-width{max-width:var(--max-content-width, 100%);margin:0 auto}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sm-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"width-margin\">\n  <div class=\"max-width\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [":host{display:flex;padding-left:var(--content-margin, 0);padding-right:var(--content-margin, 0);align-items:center}:host.animate-background{position:relative;background:var(--background-color);z-index:1}:host.animate-background:before{position:absolute;content:\"\";top:0;right:0;bottom:0;left:0;background-image:var(--linear-gradient-animation);background-position:center center;background-repeat:no-repeat;background-size:cover;z-index:-1;opacity:var(--animate-state, 0)}.width-margin{width:100%}.max-width{max-width:var(--max-content-width, 100%);margin:0 auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { animateOnScroll: [{
                type: Input
            }], abc: [{
                type: HostBinding,
                args: ['class.animate-background']
            }], onWindowScroll: [{
                type: HostListener,
                args: ["window:scroll", []]
            }] } });

class ContainerModule {
}
ContainerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ContainerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: ContainerModule, declarations: [ContainerComponent], exports: [ContainerComponent] });
ContainerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ContainerModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: ContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ContainerComponent
                    ],
                    imports: [],
                    exports: [ContainerComponent],
                    providers: [],
                    bootstrap: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ContainerComponent, ContainerModule };
